// Runtime configuration loaded from window.ENV
// This allows configuration to be injected at container startup

interface RuntimeConfig {
  AZURE_CLIENT_ID: string;
  AZURE_TENANT_ID: string;
  OIDC_AUTHORITY: string;
  REDIRECT_URI: string;
  TENANT_MANAGER_URL: string;
  CHAT_BACKEND_URL: string;
}

declare global {
  interface Window {
    ENV?: RuntimeConfig;
  }
}

// Get configuration from window.ENV with fallback to process.env for development
export const getRuntimeConfig = (): RuntimeConfig => {
  if (window.ENV) {
    return window.ENV;
  }

  // Fallback to process.env for local development
  return {
    AZURE_CLIENT_ID: process.env.REACT_APP_AZURE_CLIENT_ID || '',
    AZURE_TENANT_ID: process.env.REACT_APP_AZURE_TENANT_ID || '',
    OIDC_AUTHORITY: process.env.REACT_APP_OIDC_AUTHORITY || '',
    REDIRECT_URI: process.env.REACT_APP_REDIRECT_URI || window.location.origin,
    TENANT_MANAGER_URL: process.env.REACT_APP_TENANT_MANAGER_URL || 'https://tenant-manager.nautailus.periscop.tech/tenant/config',
    CHAT_BACKEND_URL: process.env.REACT_APP_CHAT_BACKEND_URL || 'http://localhost:3002',
  };
};

export default getRuntimeConfig;
